var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C5.51067 0 2.67188 2.8388 2.67188 6.32812C2.67188 7.50705 2.99844 8.65758 3.61649 9.65573L8.63979 17.7507C8.73601 17.9058 8.90553 18 9.08786 18C9.08926 18 9.09063 18 9.09204 18C9.27594 17.9986 9.44582 17.9014 9.54028 17.7436L14.4355 9.57023C15.0195 8.59317 15.3281 7.47207 15.3281 6.32812C15.3281 2.8388 12.4893 0 9 0ZM13.5304 9.02876L9.07988 16.4597L4.5129 9.10005C3.99846 8.26924 3.71953 7.31074 3.71953 6.32812C3.71953 3.42035 6.09223 1.04766 9 1.04766C11.9078 1.04766 14.277 3.42035 14.277 6.32812C14.277 7.2816 14.0164 8.21559 13.5304 9.02876Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.16406C7.25534 3.16406 5.83594 4.58346 5.83594 6.32812C5.83594 8.06164 7.23224 9.49219 9 9.49219C10.7896 9.49219 12.1641 8.04259 12.1641 6.32812C12.1641 4.58346 10.7447 3.16406 9 3.16406ZM9 8.44453C7.83081 8.44453 6.88359 7.49415 6.88359 6.32812C6.88359 5.16502 7.83689 4.21172 9 4.21172C10.1631 4.21172 11.1129 5.16502 11.1129 6.32812C11.1129 7.47714 10.1877 8.44453 9 8.44453Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.8291fb47aa34d2d052b400600b4d0374.svg";
export { ForwardRef as ReactComponent };